module.exports = __webpack_public_path__ + "static/award_dda-d8390e126305f007f5c8e640d7a544a9.png";